// extracted by css-extract-rspack-plugin
export default {"formElementsContainer":"IssueFormElements-module__formElementsContainer__uT6s9","markdownElementWrapper":"IssueFormElements-module__markdownElementWrapper__c00FO"};